<template>
  <transition name="fade-up" mode="out-in" appear>
    <template v-if="activeFolder">
      <jump-start-module :key="'folder' + activeFolder.id" :module="activeFolder"></jump-start-module>
    </template>

    <start-page :videos="videos" v-else>
      <v-col v-for="item in folders" :key="item.id">
        <v-btn
          class="training-button"
          color="primary"
          elevation="2"
          :to="'/jump-start/' + item.id"
        >
          <span>{{ item.title }}</span>
        </v-btn>
      </v-col>
    </start-page>
  </transition>
</template>

<script>
import StartPage from './StartPage.vue';
import JumpStartModule from './Folder.vue';

export default {
  name: 'JumpStartIndex',
  components: { StartPage, JumpStartModule },
  data: () => ({
    items: [],
  }),
  mounted() {
    this.$http.get('contents/jump-start')
      .then((response) => {
        this.items = response.data;
      });
  },
  computed: {
    activeFolder() {
      const folder = this.items.find((c) => !c.link && c.id === this.activeFolderId);
      return folder || null;
    },
    activeFolderId() {
      return parseInt(this.$route.params.id, 10);
    },
    videos() {
      return this.items.filter((item) => item.link);
    },
    folders() {
      return this.items.filter((item) => !item.link);
    },
  }
}
</script>

<style lang="scss">
.iframe-shadowed {
  -webkit-box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.51);
  -moz-box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.51);
  box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.51);
}

.training-button {
  width: 100%;
  height: 65px !important;

  span {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 2rem;
    text-transform: none;
    font-family: "Roboto", sans-serif !important;
  }
}
</style>